export enum EVideosRoutes {
  MY_VIDEOS = '/my-videos'
}
